/* External */
import { useCallback, memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Icon from '@dtvgo/icon';

/* Components */
import Input from '../Input';

/* Utils */
import { noOp } from '../../utils/functions';

/* Styles */
import './CustomInputSearch.scss';

function CustomInputSearch({
  className,
  inputValue,
  placeholder,
  onChange,
}) {
  const handleChange = useCallback((event) => {
    onChange(event.target.value);
  }, [onChange]);

  return (
    <div className={`dtv-html5-c-custom-input-search ${className}`}>
      <Icon name="search" className="dtv-html5-c-custom-input-search__icon" />
      <Input
        value={inputValue}
        className="dtv-html5-c-custom-input-search__input-field"
        placeholder={placeholder}
        type="text"
        disabled
        onChange={handleChange}
      />
    </div>
  );
}

CustomInputSearch.defaultProps = {
  className: '',
  inputValue: '',
  placeholder: '',
  onChange: noOp,
};

CustomInputSearch.propTypes = {
  className: PropTypes.string,
  inputValue: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export default memo(CustomInputSearch);
